
// styles and images
import './Project.css'

// styles and images 
import './Project.css'
import Edit from '../../assets/edit.svg'
import Delete from '../../assets/delete.svg'
import { projectStore } from '../../store/Store'

export default function ProjectSand({setEditTrigger, setDeleteTrigger, setEditId, setDeleteFields}) {
    // global
    const projectSandRates = projectStore(data => data.projectSandRates)
    const setProjectSandRates = projectStore(data => data.setProjectSandRates)
    const setProjectLoads = projectStore((data) => data.setProjectLoads);
    const setProjectTotals = projectStore((data) => data.setProjectTotals);
    const currentProject = projectStore(data => data.currentProject)

    const handleEdit = (id) => {
        setEditTrigger(true)
        setEditId(id)
    }
    
    const handleDelete = (id) => {
        setDeleteTrigger(true)
        setDeleteFields({
            setTrigger: setDeleteTrigger,
            id: id,
            table: 'project_sand_rates_tbl',
            endpoint: 'project/sand',
            nameField: 'po_number',
            setStates: [setProjectSandRates, setProjectLoads, setProjectTotals],
            setStateFields: ["project_sand_rates", "project_loads", "project_totals"]
          })
        setEditId(id)
    }
        
    return projectSandRates && (
        <div className='col-3'>
            <div className="p-2 border text-center project-card">
            <div className='d-flex justify-content-between project-header'>
                <h5>Sand Rates</h5>
            </div>
            <div className='project-card-list'>
                    <table className='table table-sm table-hover'>
                        <thead>
                            <tr>
                                <th>PO Number</th>
                                <th>Rev $/ton</th>
                                <th>Cost $/ton</th>
                                {!currentProject.project.archived && <th>Action</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {projectSandRates.map((rate, idx) => (
                                <tr key={idx}>
                                    <td>{rate.po_number}</td>
                                    <td>{rate.rev_rate}</td>
                                    <td>{rate.cost_rate}</td>
                                    {!currentProject.project.archived && <td className='action'>
                                        <div className='d-flex justify-content-between'>
                                            <img 
                                                src={Edit} 
                                                className='edit'
                                                onClick={() => handleEdit(rate.id)}
                                                alt='edit'
                                            />
                                            <img 
                                                src={Delete}
                                                className='edit'
                                                onClick={() => handleDelete(rate.id)}
                                                alt='delete'
                                            />
                                        </div>
                                    </td>}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
    }
